//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Object.js";
import "../Motion/Motion.MotionSession.js";
let d=[[],[[["listWarning"],"ModelCheck",{},1,0],[["listWarning"],"ModelCheckNoRecreateModel",{},1,0],[["source","destination"],"CopyParameters",{},2,0],[["entity","fileName"],"ExportParameters",{},2,0],[["entity","fileName"],"ImportParameters",{},2,0],[["part"],"GetGlobalSelectionBuilder",{R_:{builder:"Motion.GlobalSelectionBuilder"}},1,0],[["objectToClone"],"CloneObject",{R_:{clonedObject:"Motion.MotionObject"}},1,0],[["objectToClone","numClones","numClonedObjects","clonedObjects"],"CloneMultipleObjects",{},2,0],[["object"],"OverrideAllInstances",{},1,0]],[]];
SPLM.Motion.MotionMethods = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Motion.MotionMethods";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;